import './DataSetAboutSkeleton.css'

export default function DataSetAboutSkeleton() {
  return (
    <section className="dataset-about skeleton-mode">
      <div className="skeleton-pulse subtitle" />
      <div className="dataset-body">
        <div className="about-grid">
          <div className="skeleton-pulse label" />
          <div className="skeleton-pulse value" />
          <div className="skeleton-pulse label" />
          <div className="skeleton-pulse value" />
          <div className="skeleton-pulse label" />
          <div className="skeleton-pulse value" />
        </div>
        <div className="dataset-description">
          <div className="skeleton-pulse subtitle-small" />
          <div className="skeleton-pulse text-block" />
          <div className="skeleton-pulse text-block" />
          <div className="skeleton-pulse text-block short" />
        </div>
      </div>
    </section>
  )
}
